import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

import {
	GetAuthSchedule,
	GetAuthScheduleModel,
	GetAuthScheduleParams,
} from 'domain/usecases/private/authorizations';

export class RemoteGetAuthSchedule implements GetAuthSchedule {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetAuthScheduleModel>,
	) {}

	async get(params?: GetAuthScheduleParams): Promise<GetAuthScheduleModel> {
		const {signal} = params || {};

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
